"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FearEffectHandler = exports.FearEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Stun_1 = require("./Stun");
class FearEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Fear;
        this.__typeName = "Fear";
        this.name = "Fear";
        this.harmful = true;
    }
}
exports.FearEffectArgs = FearEffectArgs;
let FearEffectHandler = class FearEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new Stun_1.StunEffectArgs(),
            duration: Duration_1.Duration.Permanent,
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
FearEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Fear)
], FearEffectHandler);
exports.FearEffectHandler = FearEffectHandler;
